import { FaInstagram } from "react-icons/fa";
import {AiOutlineFacebook} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'
import {AiOutlineLinkedin} from 'react-icons/ai'

const data = [
    {id:1, link: 'https://www.linkedin.com/in/stamatis-platokoukis/', icon: <AiOutlineLinkedin/>},
    {id:2, link: 'https://github.com/stplato', icon: <AiFillGithub/>},
    {id:3, link: 'https://www.instagram.com/stamplato/', icon: <FaInstagram />},
    {id:4, link: 'https://www.facebook.com/platokoukis.stamatis', icon: <AiOutlineFacebook/>}
]

export default data